export default __webpack_public_path__ + "static/media/loading.d55d1b14.gif";